import { render, staticRenderFns } from "./lt-sub-task-list-item.vue?vue&type=template&id=40a2d72c&scoped=true&"
import script from "./lt-sub-task-list-item.vue?vue&type=script&lang=js&"
export * from "./lt-sub-task-list-item.vue?vue&type=script&lang=js&"
import style0 from "./lt-sub-task-list-item.vue?vue&type=style&index=0&id=40a2d72c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a2d72c",
  null
  
)

export default component.exports